import { Box, Paper, Tooltip, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import SingleSelect from 'components/common/SingleSelect';

function SyncAnchorTimezone({
	timeZone,
	timeZones = [],
	onTimeZoneChange,
	readOnly = false,
}) {
	return (
		<Paper
			variant='outlined'
			sx={{
				px: 3,
				py: 2,
				borderRadius: 0.8,
				backgroundColor: 'background.default',
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
				<Typography
					variant='subtitle1'
					sx={{
						fontWeight: 600,
						mb: 0.1,
						fontSize: '0.9rem',
					}}
				>
					Sync Anchor Timezone
				</Typography>

				{readOnly && (
					<Tooltip
						title='This setting is controlled by your tenant admin'
						placement='top'
						arrow
						slotProps={{
							tooltip: {
								sx: {
									borderRadius: '5px',
								},
							},
						}}
					>
						<InfoOutlined
							aria-label='Sync anchor timezone information'
							sx={{
								fontSize: '1rem',
								color: 'text.secondary',
								cursor: 'help',
								mb: 0.3,
							}}
						/>
					</Tooltip>
				)}
			</Box>

			<Typography
				variant='body2'
				color='text.secondary'
				sx={{
					fontSize: '0.8rem',
					mb: 1,
				}}
			>
				Timezone used to anchor automatic email syncs.
			</Typography>

			<Box sx={{ width: '100%', maxWidth: 400 }}>
				<SingleSelect
					value={timeZone}
					options={timeZones}
					onChange={onTimeZoneChange}
					placeholder='Select a timezone'
					dataTestId='email-sync-time-zone-select'
					disabled={readOnly}
				/>
			</Box>
		</Paper>
	);
}

SyncAnchorTimezone.propTypes = {
	timeZone: PropTypes.string,
	timeZones: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})
	),
	onTimeZoneChange: PropTypes.func,
	readOnly: PropTypes.bool,
};

export default SyncAnchorTimezone;
